import { useRef,useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from '../contexts/LanguageContext';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from "react-router-dom";
import messages from '../lang/preferences';
import Axios from 'axios';
import url from '../constants/urlsPaths';
import SEO from './SEO';

import './Login.css';

export default function Login({ setToken, context=null }) {
    const [email, setEmail] = useState('');
    const [key, setKey] = useState('');
    const [displayErrorEmail, setDisplayErrorEmail] = useState(false);
    const [displayErrorPassowrd, setDisplayErrorPassword] = useState(false);
    const [displaySuccess, setDisplaySuccess] = useState(false);
    const { themeValue } = useContext(ThemeContext);
    const { selectLanguage } = useContext(LanguageContext);
    //let history = useHistory();
    const location = useLocation();
    const history = useHistory();
    const isMounted = useRef(true);
    const timeouts = useRef([]);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const emailParam = urlParams.get('email');
        const keyParam = urlParams.get('key');
        
        if (emailParam) {
            setEmail(emailParam);
            console.log('📧 Email auto-populated from URL:', emailParam);
        }
        
        if (keyParam) {
            setKey(keyParam);
            console.log('🔑 Key auto-populated from URL:', keyParam);
        }
        
        // ✅ Optional: Auto-submit if both parameters are present
        if (emailParam && keyParam) {
            console.log('🚀 Both email and key found - auto-populating form');
            // Uncomment the next line if you want auto-login:
            // setTimeout(() => handleSubmit(new Event('submit')), 1000);
        }
    }, [location.search]);

     useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
            // Clear all pending timeouts
            timeouts.current.forEach(timeout => clearTimeout(timeout));
            timeouts.current = [];
        };
    }, []);

    const displayErrorMessage = (data) => {
        switch (data.errType) {
            case 1:
                setDisplayErrorEmail(true);
                timeouts.current.push(setTimeout(function () {
                    if (isMounted.current) setDisplayErrorEmail(false);
                }, 5000));
                break;
            case 2:
                setDisplayErrorPassword(true);
                timeouts.current.push(setTimeout(function () {
                    if (isMounted.current) setDisplayErrorPassword(false);
                }, 5000));
                break;
            default:
                console.log("Error")
                break;
        }
    }
    const displaySuccessMessage = (data) => {
        setDisplaySuccess(true);
        timeouts.current.push(setTimeout(function () {
            if (isMounted.current) {
                setDisplaySuccess(false);
                selectLanguage(data.language)
                setToken(data);
                // After login, if a redirect query param is present, navigate there
                const urlParams = new URLSearchParams(location.search);
                const redirectTo = urlParams.get('redirect');
                if (redirectTo) {
                    history.replace(redirectTo);
                }
            }
        }, 1000));
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        Axios.post(url.login, {
            email: email,
            userKey: key,
        }).then((response) => {
            if (response.data.auth === false) {
                displayErrorMessage(response.data)
            }
            // si connexion réussie
            else {
                console.log('🔑 Connexion réussie:', response.data);
                displaySuccessMessage(response.data);
            }
        })
    }
    // Info-footer multilingual logic (robust, inside component)
    const titleKey = `INFO_FOOTER_TITLE`;
    const textKey = `INFO_FOOTER_TEXT`;
    const titleMsg = messages[titleKey] && messages[titleKey].id ? messages[titleKey] : messages.INFO_FOOTER_TITLE;
    const textMsg = messages[textKey] && messages[textKey].id ? messages[textKey] : messages.INFO_FOOTER_TEXT;

    return (
        <div>
            <SEO 
                title={context === "results" ? "View Your Results - PPE SCOPE" : context === "login" ? "Login - PPE SCOPE" : "Manager Portal - PPE SCOPE"}
                description={context === "results" ? "Access your personality assessment results and professional development reports." : "Login to access your PPE SCOPE personality assessment and professional development tools."}
                canonical={context === "results" ? "https://ppe-scope.ch/results" : context === "login" ? "https://ppe-scope.ch/" : "https://ppe-scope.ch/manager"}
            />
            <div id="Login" className={themeValue === "day" ? "" : "nightDiv"}>
                <div id="Login-content">
                    {
                        context === "login" ? <div><br></br><p className="intro-text"><FormattedMessage {...messages.LOGIN_TEXT} /></p><br></br><br></br><h2 style={{ textAlign: "center", marginBottom: "20px" }}><FormattedMessage {...messages.LOGIN_TITLE} /></h2></div> : context === "results" ? <div><span className="login-subtitle"><br></br><h2>Results Portal</h2><br></br></span></div> : <div><span className="login-subtitle"><br></br><h2>Manager Portal</h2><br></br></span></div>
                    }
                    <form id="Login-form" onSubmit={handleSubmit}>
                        <label>
                            <p><FormattedMessage {...messages.LOGIN_EMAIL} /></p>
                            <input 
                                type="email" 
                                value={email}
                                onChange={e => setEmail(e.target.value)} 
                                autoComplete="email"
                                required 
                            />
                        </label>
                        <label>
                            <p><FormattedMessage {...messages.LOGIN_KEY} /></p>
                            <input 
                                type="password" 
                                value={key}
                                onChange={e => setKey(e.target.value)} 
                                autoComplete="current-password"
                                required 
                            />
                        </label>
                        <div>
                            <button type="submit"><FormattedMessage {...messages.LOGIN_BTN_CONNEXION} /></button>
                        </div>
                    </form>
                    <div className="Login-toasts">
                        {
                            displayErrorEmail ? <span className="Login-toast-fail"><FormattedMessage {...messages.MSG_WRONG_EMAIL} /></span> : null
                        }
                        {
                            displayErrorPassowrd ? <span className="Login-toast-fail"><FormattedMessage {...messages.MSG_WRONG_PASS} /></span> : null
                        }
                        {
                            displaySuccess ? <span className="Login-toast-success" style={{ color: "rgb(113, 219, 122)" }}><FormattedMessage {...messages.MSG_SUCCESS} /></span> : null
                        }
                    </div>
                    {
                        context === "login" && location.pathname === "/" && !location.search ?
                        <div style={{maxWidth: 600, margin: "30px auto 0 auto"}}>
                            <footer className="info-footer" style={{padding: "25px 25px", background: "#f5f7fa", borderTop: "1px solid #e0e0e0", textAlign: "center", borderRadius: "8px"}}>
                                <strong><FormattedMessage {...titleMsg} /></strong>
                                <p style={{margin: "10px 0 0 0"}}>
                                    <FormattedMessage
                                        {...textMsg}
                                        values={{
                                            link: (chunks) => (
                                                <a href="https://ppe-evaluation.com" target="_blank" rel="noopener noreferrer">{chunks}</a>
                                            )
                                        }}
                                    />
                                </p>
                            </footer>
                        </div>
                        : null
                    }
                </div>
            </div>
        </div>
    )
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired
}
